






















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { getCollectionLetterHistory, CollectionLetterModel } from "@/api/LetterHistory";
import { CollectionEventDetailsModel } from "@/api/CollectionEvents";
import { LoadingStore } from "@/store/loadingStore";
import { Observer } from "mobx-vue";
import userStore from "@/store/userStore";
import notificationStore from "../../store/notificationStore";
import { CollectionIssueEventModel } from "@/api/CollectionIssueHistory";
import collectionIssueLetterHistoryEditStore from "@/store/collectionIssueLetterHistoryEditStore";

@Observer
@Component
export default class LetterHistory extends Vue {
  @Prop(Object) readonly collectionEvent?: CollectionEventDetailsModel | CollectionIssueEventModel;
  @Prop({ default: "" }) readonly deleteText?: string;

  collectionIssueLetterHistoryEditStore = collectionIssueLetterHistoryEditStore;

  headers = this.deleteText
    ? [
        { text: "Timestamp", value: "dateGenerated" },
        { text: "Template", value: "templateName" },
        { text: "User", value: "generatedBy" },
        { text: "Action", value: "action" }
      ]
    : [
        { text: "Timestamp", value: "dateGenerated" },
        { text: "Template", value: "templateName" },
        { text: "User", value: "generatedBy" }
      ];
  loading = new LoadingStore();

  async mounted() {
    await this.fetchData();
  }

  @Watch("collectionEvent")
  private onCollectionEventChange() {
    this.fetchData();
  }

  deleteSelectedLetterHistory(collectionLetterModel: CollectionLetterModel) {
    collectionIssueLetterHistoryEditStore.selectedLetterHistory = collectionLetterModel;
    this.$emit("deleteSelectedLetterHistory");
  }

  private async fetchData() {
    if (!this.collectionEvent || !this.collectionEvent.addressStreetName) return;

    const request = {
      addressUnitNo: this.collectionEvent.addressUnitNo,
      addressStreetNo: this.collectionEvent.addressStreetNo,
      addressStreetName: this.collectionEvent.addressStreetName,
      addressSuburbName: this.collectionEvent.addressSuburbName,
      addressStateCode: this.collectionEvent.addressStateCode,
      addressPostCode: this.collectionEvent.addressPostCode,
      addressCountry: this.collectionEvent.addressCountry,
      council: userStore.activeCouncil || ""
    };
    await this.loading.track(async () => {
      try {
        collectionIssueLetterHistoryEditStore.letterHistory = await getCollectionLetterHistory(request);
      } catch (error) {
        notificationStore.error("An unexpected error occurred while loading letter history");
      }
    });
  }
}
